import { render, staticRenderFns } from "./ChangeHistory.vue?vue&type=template&id=a2f4da5e&scoped=true"
import script from "./ChangeHistory.vue?vue&type=script&lang=js"
export * from "./ChangeHistory.vue?vue&type=script&lang=js"
import style0 from "./ChangeHistory.vue?vue&type=style&index=0&id=a2f4da5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f4da5e",
  null
  
)

export default component.exports